import React from 'react';
import Modal from './Modal';
import SearchFormWrapper from './SearchFormWrapper';
import { getImage } from '../../utils/pathHelper';
import mapPinSvg from '../images/mapPin.svg';
import stylesCommon from '../styles/Common.module.scss'
import styles from '../styles/HotelPlansSearch.module.scss';
import i18n from '../../i18n';
import { SearchParams } from '../types';


type SearchFormResortProps = {
  featuredAreaCodes: string[];
  otherAreaCodes: string[];
  selectedAreaCodes: string[];
  onChangeSelectedAreaCodes: (selectedAreaCodes: string[]) => void;
}

const SearchFormArea: React.FC<SearchFormResortProps> = ({ featuredAreaCodes, otherAreaCodes, selectedAreaCodes, onChangeSelectedAreaCodes }) => {
  const [isModalShown, setModalShown] = React.useState(false);
  const [isOtherAreaHidden, setIsOtherAreaHidden] = React.useState(true);

  const onClickAreaButton = (areaCode: string) => {
    if (selectedAreaCodes.some(code => code === areaCode)) {
      const newSelectedAreaCodes = selectedAreaCodes.filter(code => code !== areaCode);
      onChangeSelectedAreaCodes(newSelectedAreaCodes);
    } else {
      onChangeSelectedAreaCodes([...selectedAreaCodes, areaCode]);
    }
  }

  const onClickAreaBadgeClose = (e: React.MouseEvent<HTMLButtonElement>, areaCode: string) => {
    e.stopPropagation()
    const newSelectedAreaCodes = selectedAreaCodes.filter(code => code !== areaCode);
    onChangeSelectedAreaCodes(newSelectedAreaCodes);
  }

  const AreaButton = ({areaCode}) => {
    const isSelected = selectedAreaCodes.some(code => code === areaCode);
    return (
      <button
        type='button'
        key={areaCode}
        className={`${stylesCommon.areaButton} ${isSelected ? stylesCommon.selected : ''}`}
        onClick={() => onClickAreaButton(areaCode)}
      >
        {i18n.t(`areas.${areaCode}`)}
      </button>
    );
  }

  return (
    <SearchFormWrapper
      onClick={() => setModalShown(true)}
      icon={<img src={getImage(mapPinSvg)} alt='' />}
    >
      <div className={stylesCommon.areaBadgeWrapper}>
        {
          selectedAreaCodes.length > 0 ?
          selectedAreaCodes.map(areaCode => {
            return (
              <div key={`search-form-area-${areaCode}`} className={stylesCommon.areaBadge}>
                {i18n.t(`areas.${areaCode}`)}
                <button className={stylesCommon.areaBadgeClose} onClick={(e) => onClickAreaBadgeClose(e, areaCode)}>×</button>
              </div>
            )
          })
          :
          <div className={stylesCommon.areaPlaceHolder}>{i18n.t('stay_packages.hotels.index.please_select_an_area')}</div>
        }
      </div>
      <div className={styles.dateForm}>
        <Modal isShown={isModalShown} handleClose={() => { setModalShown(false); }} title={''} whiteMode={true} >
          <div
            className={`${stylesCommon.areaModalInput} d-flex align-items-center p-2 my-2 bg-white rounded`}
            style={{ cursor: 'pointer' }}
          >
            <div className="mr-3">{<img src={getImage(mapPinSvg)} alt='' />}</div>
            <div className={`${stylesCommon.areaBadgeWrapper} w-100`}>
              {
                selectedAreaCodes.length > 0 ?
                selectedAreaCodes.map(areaCode => {
                  return (
                    <div key={`search-form-area-modal-${areaCode}`} className={stylesCommon.areaBadge}>
                      {i18n.t(`areas.${areaCode}`)}
                      <button className={stylesCommon.areaBadgeClose} onClick={(e) => onClickAreaBadgeClose(e, areaCode)}>×</button>
                    </div>
                  )
                })
                :
                <div className={stylesCommon.areaPlaceHolder}>{i18n.t('stay_packages.hotels.index.please_select_an_area')}</div>
              }
            </div>
          </div>
          <div className={stylesCommon.areaHeader}>{i18n.t('stay_packages.hotels.index.popular_areas')}</div>
          <div className={stylesCommon.areaButtonWrapper}>
            {featuredAreaCodes.map(areaCode => (
              <AreaButton key={`search-form-area-popular-${areaCode}`} areaCode={areaCode} />
            ))}
          </div>
          <button className={stylesCommon.areaHeader} onClick={()=>{setIsOtherAreaHidden(!isOtherAreaHidden)}} data-toggle="collapse" type="button" aria-expanded={!isOtherAreaHidden} aria-controls="SearchFormAreaOtherArea">
            {i18n.t('stay_packages.hotels.index.other_areas')}
            { isOtherAreaHidden ? <i className="fas fa-chevron-down ml-3"/> : <i className="fas fa-chevron-up ml-3"/> }
          </button>
          <div className={`${stylesCommon.areaButtonWrapper} ${isOtherAreaHidden && stylesCommon.hidden}`} id="SearchFormAreaOtherArea">
            {otherAreaCodes.map(areaCode => (
              <AreaButton key={`search-form-area-other-${areaCode}`} areaCode={areaCode} />
            ))}
          </div>
          <div className="d-flex justify-content-center mt-4">
            <button
              className="col-12 col-md-5 btn btn-primary rounded-pill font-weight-bold"
              type='button'
              onClick={() => setModalShown(false)}>
              { i18n.t('base.confirm') }
            </button>
          </div>
        </Modal>
      </div>
    </SearchFormWrapper>
  );
}

export default SearchFormArea;
